"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinancialDate = void 0;
const moment_1 = require("moment");
class FinancialDate {
    // Assumes creation ass YYYY-MM-DD
    constructor() {
    }
    static fromMoment(m, alreadyCloned) {
        const fd = new FinancialDate();
        if (alreadyCloned) {
            fd.dateMoment = m;
        }
        else {
            fd.dateMoment = m.clone();
        }
        return fd;
    }
    static fromString(yyyymmddDate) {
        const fd = new FinancialDate();
        fd.dateMoment = moment_1.utc(yyyymmddDate, 'YYYY-MM-DD');
        return fd;
    }
    toString() {
        return this.getDateString();
    }
    getDateString() {
        return this.dateMoment.format('YYYY-MM-DD');
    }
    format(mask) {
        return this.dateMoment.format(mask);
    }
    getUnderlyingModel() {
        return this.dateMoment;
    }
    clone() {
        return FinancialDate.fromMoment(this.dateMoment.clone(), true);
    }
    addDays(noOfDays) {
        return FinancialDate.fromMoment(this.dateMoment.clone().add(noOfDays, 'days').startOf('day'), true);
    }
    addWeeks(noOfWeeks) {
        return FinancialDate.fromMoment(this.dateMoment.clone().add(noOfWeeks, 'weeks').startOf('day'), true);
    }
    addMonths(noOfMonths) {
        return FinancialDate.fromMoment(this.dateMoment.clone().add(noOfMonths, 'months').startOf('day'), true);
    }
    firstDayOfWeek() {
        return FinancialDate.fromMoment(this.dateMoment.clone().startOf('week').startOf('day'), true);
    }
    lastDayOfWeek() {
        return FinancialDate.fromMoment(this.dateMoment.clone().endOf('week').startOf('day'), true);
    }
    firstDayOfMonth() {
        return FinancialDate.fromMoment(this.dateMoment.clone().startOf('month').startOf('day'), true);
    }
    lastDayOfMonth() {
        return FinancialDate.fromMoment(this.dateMoment.clone().endOf('month').startOf('day'), true);
    }
    firstDayOfQuarter() {
        return FinancialDate.fromMoment(this.dateMoment.clone().startOf('quarter').startOf('day'), true);
    }
    lastDayOfQuarter() {
        return FinancialDate.fromMoment(this.dateMoment.clone().endOf('quarter').startOf('day'), true);
    }
    firstDayOfYear() {
        return FinancialDate.fromMoment(this.dateMoment.clone().startOf('year').startOf('day'), true);
    }
    lastDayOfYear() {
        return FinancialDate.fromMoment(this.dateMoment.clone().endOf('year').startOf('day'), true);
    }
    getDaysDiff(other, needsInteger) {
        return this.dateMoment.diff(other.dateMoment, 'days', !needsInteger);
    }
    getMonthDiff(other, needsInteger) {
        return this.dateMoment.diff(other.dateMoment, 'months', !needsInteger);
    }
    getMonth() {
        // Moment (like JS Date) returns the zero indexed index for month
        // ... which is confusing because day returns the day of the month starting at 1
        // This method will return the month number
        return this.dateMoment.get('month') + 1;
    }
    getMonthIndex() {
        return this.dateMoment.get('month');
    }
    getYear() {
        return this.dateMoment.get('year');
    }
    getDay() {
        return this.dateMoment.get('day');
    }
    getDate() {
        return this.dateMoment.get('date');
    }
    // 0 = Sunday 6 = Saturday
    getDayOfWeekIndex() {
        return this.dateMoment.day();
    }
    isAfter(otherDate) {
        return this.dateMoment.isAfter(otherDate.dateMoment, "days");
    }
    isSameOrAfter(otherDate) {
        return this.dateMoment.isSameOrAfter(otherDate.dateMoment, "days");
    }
    isBefore(otherDate) {
        return this.dateMoment.isBefore(otherDate.dateMoment, "days");
    }
    isSameOrBefore(otherDate) {
        return this.dateMoment.isSameOrBefore(otherDate.dateMoment, "days");
    }
    isSame(otherDate) {
        return this.dateMoment.isSame(otherDate.dateMoment, "days");
    }
    isValid() {
        return this.dateMoment.isValid();
    }
}
exports.FinancialDate = FinancialDate;
//# sourceMappingURL=financial-date.js.map